import type { PhoneNumberSettings } from '../../phoneNumber.types.ts';

const PHONE_NUMBER: PhoneNumberSettings = {
  country: 'GB',
  defaultPrefix: 'GB+44',
  placeholder: 'Enter your number',
  showCountryPrefix: true,
  formatNationalInput: true,
};

export { PHONE_NUMBER };
